/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CourtHearingDutyCounselorResponse } from './CourtHearingDutyCounselorResponse';
import {
    CourtHearingDutyCounselorResponseFromJSON,
    CourtHearingDutyCounselorResponseFromJSONTyped,
    CourtHearingDutyCounselorResponseToJSON,
    CourtHearingDutyCounselorResponseToJSONTyped,
} from './CourtHearingDutyCounselorResponse';
import type { CourtHearingCourtResponse } from './CourtHearingCourtResponse';
import {
    CourtHearingCourtResponseFromJSON,
    CourtHearingCourtResponseFromJSONTyped,
    CourtHearingCourtResponseToJSON,
    CourtHearingCourtResponseToJSONTyped,
} from './CourtHearingCourtResponse';
import type { TimeDate } from './TimeDate';
import {
    TimeDateFromJSON,
    TimeDateFromJSONTyped,
    TimeDateToJSON,
    TimeDateToJSONTyped,
} from './TimeDate';
import type { CourtHearingClientResponse } from './CourtHearingClientResponse';
import {
    CourtHearingClientResponseFromJSON,
    CourtHearingClientResponseFromJSONTyped,
    CourtHearingClientResponseToJSON,
    CourtHearingClientResponseToJSONTyped,
} from './CourtHearingClientResponse';

/**
 * 
 * @export
 * @interface CourtHearingResponse
 */
export interface CourtHearingResponse {
    /**
     * 
     * @type {string}
     * @memberof CourtHearingResponse
     */
    courseEntryId: string;
    /**
     * 
     * @type {Date}
     * @memberof CourtHearingResponse
     */
    date: Date;
    /**
     * 
     * @type {TimeDate}
     * @memberof CourtHearingResponse
     */
    time: TimeDate;
    /**
     * 
     * @type {CourtHearingCourtResponse}
     * @memberof CourtHearingResponse
     */
    court: CourtHearingCourtResponse | null;
    /**
     * 
     * @type {CourtHearingClientResponse}
     * @memberof CourtHearingResponse
     */
    client: CourtHearingClientResponse;
    /**
     * 
     * @type {string}
     * @memberof CourtHearingResponse
     */
    fileNumber: string | null;
    /**
     * 
     * @type {CourtHearingDutyCounselorResponse}
     * @memberof CourtHearingResponse
     */
    dutyCounselor: CourtHearingDutyCounselorResponse | null;
}

/**
 * Check if a given object implements the CourtHearingResponse interface.
 */
export function instanceOfCourtHearingResponse(value: object): value is CourtHearingResponse {
    if (!('courseEntryId' in value) || value['courseEntryId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('court' in value) || value['court'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('fileNumber' in value) || value['fileNumber'] === undefined) return false;
    if (!('dutyCounselor' in value) || value['dutyCounselor'] === undefined) return false;
    return true;
}

export function CourtHearingResponseFromJSON(json: any): CourtHearingResponse {
    return CourtHearingResponseFromJSONTyped(json, false);
}

export function CourtHearingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtHearingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'courseEntryId': json['courseEntryId'],
        'date': (new Date(json['date'])),
        'time': TimeDateFromJSON(json['time']),
        'court': CourtHearingCourtResponseFromJSON(json['court']),
        'client': CourtHearingClientResponseFromJSON(json['client']),
        'fileNumber': json['fileNumber'],
        'dutyCounselor': CourtHearingDutyCounselorResponseFromJSON(json['dutyCounselor']),
    };
}

export function CourtHearingResponseToJSON(json: any): CourtHearingResponse {
    return CourtHearingResponseToJSONTyped(json, false);
}

export function CourtHearingResponseToJSONTyped(value?: CourtHearingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courseEntryId': value['courseEntryId'],
        'date': `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'time': TimeDateToJSON(value['time']),
        'court': CourtHearingCourtResponseToJSON(value['court']),
        'client': CourtHearingClientResponseToJSON(value['client']),
        'fileNumber': value['fileNumber'],
        'dutyCounselor': CourtHearingDutyCounselorResponseToJSON(value['dutyCounselor']),
    };
}

